// Kessem — header / footer logo, sourced from public/brand/Logo Kessem.svg
// (a black PK monogram). The previous SVG-generated sparkle + "kessem"
// wordmark is replaced by this single artwork.
//
// The SparkleVariant prop and `monochrome` / `sparkle` props are kept on
// the type so existing call sites compile unchanged, but they're not
// applied to the rendered output.

import { KESSEM_BRAND, LOGO_SIZE } from "./logo-config";

export type SparkleVariant = "sharp" | "soft" | "glow" | "spark" | "dual";

type LogoProps = {
  variant?: "light" | "dark";
  size?: "sm" | "md" | "lg" | number;
  monochrome?: boolean;
  /** Kept for API compatibility — no longer drives a rendered variant. */
  sparkle?: SparkleVariant;
  className?: string;
  ariaLabel?: string;
};

// viewBox in the source SVG is 296×292 after we cropped out the empty
// padding — gives an almost-square monogram so it stays balanced next to
// header text.
const LOGO_ASPECT = 296 / 292;
const LOGO_SRC = "/brand/Logo%20Kessem.svg";

export function Logo({
  variant = "light",
  size = "md",
  className,
  ariaLabel = "Kessem",
}: LogoProps) {
  const heightPx = typeof size === "number" ? size : LOGO_SIZE[size];
  const widthPx = Math.round(heightPx * LOGO_ASPECT);
  return (
    <span
      role="img"
      aria-label={ariaLabel}
      className={`inline-flex items-center ${className ?? ""}`}
      style={{ height: heightPx, color: KESSEM_BRAND.inkDark }}
    >
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={LOGO_SRC}
        alt=""
        width={widthPx}
        height={heightPx}
        className="block shrink-0"
        // SVG is filled in pure black. For "light" variant (logo on a
        // dark surface) we invert it to white via CSS filter so we don't
        // need to ship two SVG files.
        style={{
          filter: variant === "light" ? "invert(1)" : undefined,
        }}
      />
    </span>
  );
}

export default Logo;
